import {AnyAction, Reducer} from 'redux'
import {State} from '../reducers'
import catalogoReducer from '../reducers/catalogos.reducer'
import {recargarCatalogosDeLaNormativa} from '../actions/catalogos.actions'
import {VERSION_NORMATIVA_V1, VERSION_NORMATIVA_V2} from '../utils/normativa.utils'

export const VERSION_CACHE_CATALOGOS = 2

export const CLAVE_VERSION_NORMATIVA_CATALOGOS = 'versionNormativaCatalogos'

export const CATALOGOS_PURGAR_CACHE = 'CATALOGOS_PURGAR_CACHE_NORMATIVA'

export const CATALOGOS_AJENOS_A_LA_NORMATIVA = [
  'datosEmisor',
  'botonesAyuda',
  'productos',
  'planFacturas',
  'serviciosAdicionales',
  'tipoCargosMembresia',
]

const CATALOGOS_REINICIAR_CACHE = 'CATALOGOS_REINICIAR_CACHE_NORMATIVA'

export const purgarCacheCatalogos = () => ({type: CATALOGOS_PURGAR_CACHE, payload: null})

const obtenerVersionNormativaEmpresa = (empresa: any): string => {
  if (!empresa) return ''
  const version = empresa.versionhacienda ?? empresa.versionHacienda
  if (version === null || version === undefined) return ''
  const valor = `${version}`.trim()
  if (valor !== VERSION_NORMATIVA_V1 && valor !== VERSION_NORMATIVA_V2) return ''
  return valor
}

const leerVersionNormativaGuardada = (): string | null => {
  try {
    return localStorage.getItem(CLAVE_VERSION_NORMATIVA_CATALOGOS)
  } catch (error) {
    return null
  }
}

const guardarVersionNormativa = (version: string) => {
  try {
    localStorage.setItem(CLAVE_VERSION_NORMATIVA_CATALOGOS, version)
  } catch (error) {
    return
  }
}

const conservarAjenosALaNormativa = (catalogosPrevios: any) =>
  CATALOGOS_AJENOS_A_LA_NORMATIVA.reduce((conservados: any, nombre: string) => {
    if (catalogosPrevios?.[nombre] !== undefined) conservados[nombre] = catalogosPrevios[nombre]
    return conservados
  }, {})

const catalogosRecienIniciados = () =>
  catalogoReducer(undefined, {type: CATALOGOS_REINICIAR_CACHE, payload: null})

export const reiniciarCatalogosPersistidos = (estadoPersistido: any) => {
  if (!estadoPersistido) return estadoPersistido
  const catalogosPrevios = estadoPersistido.catalogos
  return {
    ...estadoPersistido,
    catalogos: {
      ...catalogosRecienIniciados(),
      ...conservarAjenosALaNormativa(catalogosPrevios),
    },
  }
}

export const migracionesPersistencia = {
  [VERSION_CACHE_CATALOGOS]: (estadoPersistido: any) =>
    reiniciarCatalogosPersistidos(estadoPersistido),
}

export const envolverConPurgaDeCatalogos = <A extends AnyAction>(
  reducerRaiz: Reducer<State, A>
): Reducer<State, A> => {
  return (estado, accion) => {
    if (accion.type !== CATALOGOS_PURGAR_CACHE || !estado) return reducerRaiz(estado, accion)

    const conservados = conservarAjenosALaNormativa(estado.catalogos)
    const estadoReiniciado = reducerRaiz(
      {...estado, catalogos: undefined} as any,
      {type: CATALOGOS_REINICIAR_CACHE} as unknown as A
    )

    return {
      ...estadoReiniciado,
      catalogos: {
        ...estadoReiniciado.catalogos,
        ...conservados,
      },
    }
  }
}

const hayCatalogosEnCache = (estado: State): boolean => {
  const catalogos = estado?.catalogos
  if (!catalogos) return false
  if (catalogos.municipios?.length > 0) return true
  if (catalogos.distritos?.length > 0) return true
  if (catalogos.departamentos?.length > 0) return true
  return Object.keys(catalogos.municipiosPorDepartamento ?? {}).length > 0
}

interface AlmacenVigilado {
  getState(): State
  dispatch(accion: AnyAction): any
  subscribe(escucha: () => void): any
}

export const vigilarVersionNormativaCatalogos = (store: AlmacenVigilado) => {
  let versionVigente = leerVersionNormativaGuardada()

  const sincronizar = () => {
    const estado = store.getState()
    const versionEmpresa = obtenerVersionNormativaEmpresa(estado?.catalogos?.datosEmisor)
    if (!versionEmpresa || versionEmpresa === versionVigente) return

    const debePurgar = versionVigente !== null || hayCatalogosEnCache(estado)
    versionVigente = versionEmpresa
    guardarVersionNormativa(versionEmpresa)

    if (!debePurgar) return

    store.dispatch(purgarCacheCatalogos())
    store.dispatch(recargarCatalogosDeLaNormativa() as any)
  }

  sincronizar()
  store.subscribe(sincronizar)
}
